// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import InfoBookingForDate from './InfoBookingForDate';

export default class RestaurantDashboardInfoBooking extends ApiObject {

  dates: Array<InfoBookingForDate> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    this.dates = [];
    _.each(data.dates, (dateInfoData) => {
      const infoBookingForDate:InfoBookingForDate = new InfoBookingForDate();
      infoBookingForDate.fromJson(dateInfoData);
      this.dates.push(infoBookingForDate);
    });
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/dashboard/RestaurantDashboardInfoBooking.js